import {Recherche} from "./Recherche.js";
import {CritèreRecherche} from "./CritèreRecherche.js";
import {OptionRecherche} from "./OptionRecherche.js";
import {Cibles} from "./Cibles.js";

export class GestionnaireURL {

    static urlParams = Object.freeze({
        "RECHERCHE_COMPRESSÉE": "r",
        "RECHERCHE_SIMPLE": "rs",
        "RECHERCHE_SIMPLE_OPTIONS": "os",
    });

    static getUrlCourante() {
        return new URL(window.location.href);
    }

    static getRechercheCompressée(url, constructeurDeRecherche) {
        const rParam = GestionnaireURL.getRechercheCompresséeParam(url);
        if (GestionnaireURL.isParamValide(rParam)) {
            const rechercheSérialisée = LZString.decompressFromEncodedURIComponent(rParam);
            if (rechercheSérialisée && Object.keys(rechercheSérialisée).length > 0) {
                return Recherche.désérialise(rechercheSérialisée, constructeurDeRecherche);
            }
        }
        return null;
    }

    /**
     * Format rs (requête simple) :
     * <pre>
     * CIBLE|COMPARATEUR|VALEUR,CIBLE|COMPARATEUR|VALEUR,CIBLE|COMPARATEUR|VALEUR,etc.
     * </pre>
     *
     * Format os (option simple) :
     * <pre>
     * OPTION|VALEUR,OPTION|VALEUR,OPTION|VALEUR,etc.
     * </pre>
     *
     * Exemple : ?rs=LISTE_MEQ|ÉGALE|1re année primaire&os=INCLURE_VERBES_CONJUGUÉS|non,LEMMES_SEULEMENT|oui
     * Exemple : ?rs=CONJUGAISON_MODÈLE|ÉGALE|acheter&os=INCLURE_VERBES_CONJUGUÉS|non,LEMMES_SEULEMENT|oui
     *
     */
    static getRechercheSimple(url, constructeurDeRecherche) {
        const critères = GestionnaireURL.getCritèresRechercheSimple(url, constructeurDeRecherche);
        const options = GestionnaireURL.getOptionsRechercheSimple(url);
        let recherche = new Recherche(critères, options, "");

        return Recherche.désérialise(JSON.stringify(recherche), constructeurDeRecherche)

    }

    static getCritèresRechercheSimple(url, constructeurDeRecherche) {
        const rsParam = GestionnaireURL.getRechercheSimpleParam(url);
        let critères = [];
        if (GestionnaireURL.isParamValide(rsParam)) {
            try {
                rsParam.split(",").forEach((critère) => {
                    const ccv = critère.split("|");
                    const cibleCode = ccv[0];
                    const comparateurCode = ccv[1];
                    const valeur = ccv[2];

                    // Récupérer toutes les valeurs possibles (possiblement multiples) de la cible
                    const cible = Cibles[ cibleCode ];
                    if(cible) {
                        const cibleValeursMultiples = cible.valeursPossibles.get(valeur);
                        if(cibleValeursMultiples) {
                            const valeursJointes = cibleValeursMultiples.join();
                            const cr = new CritèreRecherche(cibleCode, comparateurCode, [valeursJointes]);
                            critères.push(cr);
                        }
                        else {
                         throw new Error("Valeur inconnue : « " + valeur + " » pour la cible « " + cibleCode + " »");
                        }
                    }
                    else {
                        throw new Error("Cible inconnue : « " + cibleCode + " »");
                    }
                })
            } catch (e) {
                console.error(e);
            }
        }
        return critères;
    }

    static getOptionsRechercheSimple(url) {
        const osParam = GestionnaireURL.getRechercheSimpleOptionsParam(url);
        let options = []
        if (GestionnaireURL.isParamValide(osParam)) {
            try {
                osParam.split(",").forEach((critère) => {
                    const cv = critère.split("|");
                    const optionCode = cv[0];
                    const optionValeur = cv[1];
                    const or = new OptionRecherche(optionCode, optionValeur);
                    options.push(or);
                })
            } catch (e) {
                console.error(e);
            }
        }
        return options;
    }

    static getRechercheCompresséeParam(url) {
        return url.searchParams.get(GestionnaireURL.urlParams.RECHERCHE_COMPRESSÉE);
    }

    static getRechercheSimpleParam(url) {
        return url.searchParams.get(GestionnaireURL.urlParams.RECHERCHE_SIMPLE);
    }

    static getRechercheSimpleOptionsParam(url) {
        return url.searchParams.get(GestionnaireURL.urlParams.RECHERCHE_SIMPLE_OPTIONS);
    }

    static isParamValide(param) {
        return (typeof param === 'string' && param && param.trim().length > 0);
    }

    static hasRechercheCompressée(url) {
        return GestionnaireURL.isParamValide(GestionnaireURL.getRechercheCompresséeParam(url));
    }

    static hasRechercheSimple(url) {
        return GestionnaireURL.isParamValide(GestionnaireURL.getRechercheSimpleParam(url));
    }

    static getRechercheURL(nomRecherche, rechercheSérialisée) {
        let nouvelleURL = GestionnaireURL.réinitialiseParamsRecherche()
        let paramètres = nouvelleURL.searchParams;
        paramètres.set(GestionnaireURL.urlParams.RECHERCHE_COMPRESSÉE, rechercheSérialisée);
        return nouvelleURL;
    }

    static réinitialiseParamsRecherche() {
        let nouvelleURL = GestionnaireURL.getUrlCourante();
        let paramètres = nouvelleURL.searchParams;
        paramètres.delete(GestionnaireURL.urlParams.RECHERCHE_COMPRESSÉE);
        paramètres.delete(GestionnaireURL.urlParams.RECHERCHE_SIMPLE);
        paramètres.delete(GestionnaireURL.urlParams.RECHERCHE_SIMPLE_OPTIONS);
        return nouvelleURL;
    }

}
